import React from 'react';
import PropTypes from 'prop-types';
import {
  ClaimAttachmentsDataContainer,
  ClaimAttachmentsLabelContainer,
  ClaimDocumentsContainer,
  DescriptionContainer,
  DocumentAddDate,
  DocumentDescription,
  DocumentName,
  DocumentTypeContainer,
  DocumentTypeLabel,
  DocumentTypeLabelMobile,
  DownloadLinkContainer,
  DownloadLinkLabel,
  DownloadLinkLabelMobile,
  FileIcon,
  LoaderMargin,
  PdfIcon,
  SectionHeader,
  SubSectionHeader,
  UploadDateContainer,
} from './styles';
import Loader from '../../common/loader';
import { ApiError } from '../../common/api-error';
import AuthenticatedLink from '../../common/authenticated-link';

export const ClaimAttachments = (props) => {
  const { isLoading, errors, claimDocuments, claimAttachments } = props;
  return (
    <ClaimDocumentsContainer>
      {isLoading ? (
        <LoaderMargin>
          <Loader />
        </LoaderMargin>
      ) : (
        <>
          <SubSectionHeader>Claim Documents</SubSectionHeader>
          <ClaimAttachmentsLabelContainer>
            <DocumentTypeLabel id="AttachmentType">Document Type</DocumentTypeLabel>
            <DocumentTypeLabel id="AttachmentDescription">Description</DocumentTypeLabel>
            <DownloadLinkLabel>Download Link</DownloadLinkLabel>
            <DocumentTypeLabel id="UploadDate">Upload Date</DocumentTypeLabel>
          </ClaimAttachmentsLabelContainer>
          {errors ? (
            <ApiError body="There was an error loading your attachments." variant="table" />
          ) : (
            <>
              {claimDocuments &&
                claimDocuments.map((document, index) => {
                  return (
                    <ClaimAttachmentsDataContainer key={document.ref}>
                      <DocumentTypeContainer $index={index}>
                        <DocumentTypeLabelMobile>Document Type</DocumentTypeLabelMobile>
                        <DocumentName $index={index} $documentName={document.name}>
                          {document.name}
                        </DocumentName>
                      </DocumentTypeContainer>
                      <DescriptionContainer>
                        <DocumentTypeLabelMobile>Description</DocumentTypeLabelMobile>
                        <DocumentDescription
                          $index={index}
                          $documentDescription={document.description}
                        >
                          {document.description}
                        </DocumentDescription>
                      </DescriptionContainer>
                      <DownloadLinkContainer $index={index}>
                        <DownloadLinkLabelMobile>Download Link</DownloadLinkLabelMobile>
                        <AuthenticatedLink
                          url={document._links[0].href}
                          filename={document.name + '.pdf'}
                          aria-label={`Download link for ${document.name}`}
                        >
                          <PdfIcon />
                          Download
                        </AuthenticatedLink>
                      </DownloadLinkContainer>
                      <UploadDateContainer>
                        <DocumentTypeLabelMobile>Upload Date</DocumentTypeLabelMobile>
                        <DocumentAddDate $index={index} $documentAddDate={document.addDt}>
                          {document.addDt}
                        </DocumentAddDate>
                      </UploadDateContainer>
                    </ClaimAttachmentsDataContainer>
                  );
                })}
            </>
          )}
          <>
            {claimAttachments && (
              <>
                <SubSectionHeader>Uploaded Attachments</SubSectionHeader>
                <ClaimAttachmentsLabelContainer>
                  <DocumentTypeLabel id="AttachmentType">Document Type</DocumentTypeLabel>
                  <DocumentTypeLabel id="AttachmentDescription">Description</DocumentTypeLabel>
                  <DownloadLinkLabel>Download Link</DownloadLinkLabel>
                  <DocumentTypeLabel id="UploadDate">Upload Date</DocumentTypeLabel>
                </ClaimAttachmentsLabelContainer>
                {claimAttachments &&
                  claimAttachments.map((document, index) => {
                    return (
                      <ClaimAttachmentsDataContainer key={document.ref}>
                        <DocumentTypeContainer $index={index}>
                          <DocumentTypeLabelMobile>Document Type</DocumentTypeLabelMobile>
                          <DocumentName $index={index} $documentName={document.name}>
                            {document.name}
                          </DocumentName>
                        </DocumentTypeContainer>
                        <DescriptionContainer>
                          <DocumentTypeLabelMobile>Description</DocumentTypeLabelMobile>
                          <DocumentDescription
                            $index={index}
                            $documentDescription={document.description}
                          >
                            {document.description}
                          </DocumentDescription>
                        </DescriptionContainer>
                        <DownloadLinkContainer $index={index}>
                          <DownloadLinkLabelMobile>Download Link</DownloadLinkLabelMobile>
                          <AuthenticatedLink
                            url={document._links[0].href}
                            filename={document.name + '.pdf'}
                            ariaLabel={`Download link for ${document.name}`}
                          >
                            <PdfIcon />
                            Download
                          </AuthenticatedLink>
                        </DownloadLinkContainer>
                        <UploadDateContainer>
                          <DocumentTypeLabelMobile>Upload Date</DocumentTypeLabelMobile>
                          <DocumentAddDate $index={index} $documentAddDate={document.addDt}>
                            {document.addDt}
                          </DocumentAddDate>
                        </UploadDateContainer>
                      </ClaimAttachmentsDataContainer>
                    );
                  })}
              </>
            )}
          </>
        </>
      )}
    </ClaimDocumentsContainer>
  );
};
ClaimAttachments.propTypes = {
  isLoading: PropTypes.bool,
  errors: PropTypes.any,
  claimDocuments: PropTypes.array,
  claimAttachments: PropTypes.array,
};
